import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { connect } from "react-redux";
import { Link, useHistory, useLocation } from "react-router-dom";

import { NewSignUpLayout } from "components/layouts";
import { SOCIAL_PROVIDERS } from "libs/constants/PepperestWebServices/Auth";
import * as actions from "../../../store/actions/index";
import { mixPanelUserProperty } from "libs/mixPanel";
import { GoogleButton, Loader } from "components/blocks";
import FloatingLabelInput from "components/blocks/InputFloatingLabel";
import FloatingPasswordInput from "components/blocks/FloatingPasswordInput";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { getStateFromLocalStorage } from "store/utility";

function Index(props) {
  const userToken = getStateFromLocalStorage("userToken");
  let location = useLocation();
  let history = useHistory();
  const [state, setState] = useState({
    loading: false,
  });
  const loginSchema = yup.object().shape({
    email: yup.string().email().required("Email is required"),
    password: yup.string().required("Password is required"),
  });

  const { register, handleSubmit, errors } = useForm({
    resolver: yupResolver(loginSchema),
  });

  const loginHandler = (data) => {
    let password = data?.password;
    let email = data?.email;
    props.onLogin(email, password);
  };

  useEffect(() => {
    const code = getParamFromUrl("code");
    if (code) {
      const provider = JSON.parse(getParamFromUrl("state")).provider;
      attemptSocialLogin(provider, code);
    }
  }, []);

  const getParamFromUrl = (param) => {
    const urlParams = new URL(document.location).searchParams;
    return urlParams.get(param);
  };

  const loginWithFacebook = () => {
    const client_id = SOCIAL_PROVIDERS.facebook.client_id;
    const redirectURL = SOCIAL_PROVIDERS.facebook.redirectURL;
    const baseURL = SOCIAL_PROVIDERS.facebook.baseURL;
    const facebookAuthURL = `${baseURL}?client_id=${client_id}&redirect_uri=${redirectURL}&state={"provider":"facebook"}`;
    window.location.replace(facebookAuthURL);
  };

  const attemptSocialLogin = (provider, code) => {
    const payLoad = {
      provider: provider,
      code: code,
    };
    props.onSocialLogin(payLoad);
  };

  let { from } = location.state || { from: { pathname: "/" } };
  useEffect(() => {
    if (props.token) {
      if (localStorage.getItem("path")) {
        history.replace("/checkout");
        localStorage.removeItem("path");
      } else if (from?.pathname === "/") {
        history.replace("/dashboard");
      } else {
        history.replace(from);
      }
    } else if (userToken) {
      history.replace("/account");
    }
  }, [props.token, userToken]);

  console.log({ userToken });
  return (
    <>
      <div>
        <nav>
          <a href="https://peppa.io">
            <img src={"/assets/images/logo/peppa_white.svg"} alt="logo" />
          </a>
        </nav>

        <main className="signUp__LeftSideBox">
          <h1 className="signUp__title">
            Start <br />
            selling <br /> with <br />
            peppa.io
          </h1>
        </main>
      </div>
      <div>
        <main>
          <h2 className="signUp__right__header">Sign in</h2>
          <p>
            <span className="pr-1">Don't have an account? </span>
            <Link
              style={{ color: "#5E60CE", textDecoration: "none" }}
              className=" text-decoration-none"
              to="/register"
            >
              Create an account
            </Link>
          </p>

          <form
            className={`nsForm auth-panel-form mt-5`}
            onSubmit={handleSubmit(loginHandler)}
          >
            <FloatingLabelInput
              label="Email address"
              type="email"
              name="email"
              hasError={errors?.email}
              register={register}
              errorMessage={errors?.email?.message}
            />
            <p className="mt-1"></p>

            <FloatingPasswordInput
              label="Password"
              name="password"
              register={register}
              hasError={errors.password}
              errorMessage={errors?.password?.message}
            />
            <div className="forget__password__wrapper">
              <Link to="/forgot-password">Forgot password</Link>
            </div>

            <button disabled={props.loading} className="button button--purple">
              {props.loading ? <Loader /> : "Login"}
            </button>

            <br />
            <div className="text-center">
              <p>Or</p>
              <p className="my-2">Login with socials</p>

              <div className="d-flex gap-3 mt-1 justify-content-center align-items-center">
                <GoogleButton>
                  <SignUpInstagramIcon />
                </GoogleButton>
                <span onClick={loginWithFacebook}>
                  <SignUpFacebookIcon />
                </span>
              </div>
            </div>
          </form>
        </main>
      </div>
    </>
  );
}

const mapStateToProps = (state) => ({
  loading: state.auth.loading,
  token: state.auth.token,
  error: state.auth.error,
});

const mapDispatchToProps = (dispatch) => ({
  onLogin: (email, password) => dispatch(actions.login(email, password)),
  onSocialLogin: (payLoad) => dispatch(actions.socialLogin(payLoad)),
});

export default NewSignUpLayout(
  connect(mapStateToProps, mapDispatchToProps)(Index),
  {}
);

const SignUpInstagramIcon = () => {
  return (
    <svg
      style={{ cursor: "pointer" }}
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M27.2569 12.5519H26.25V12.5H15V17.5H22.0644C21.0338 20.4106 18.2644 22.5 15 22.5C10.8581 22.5 7.5 19.1419 7.5 15C7.5 10.8581 10.8581 7.5 15 7.5C16.9119 7.5 18.6513 8.22125 19.9756 9.39937L23.5112 5.86375C21.2787 3.78312 18.2925 2.5 15 2.5C8.09688 2.5 2.5 8.09688 2.5 15C2.5 21.9031 8.09688 27.5 15 27.5C21.9031 27.5 27.5 21.9031 27.5 15C27.5 14.1619 27.4137 13.3438 27.2569 12.5519Z"
        fill="#FFC107"
      />
      <path
        d="M3.94141 9.18188L8.04828 12.1938C9.15953 9.4425 11.8508 7.5 15.0002 7.5C16.912 7.5 18.6514 8.22125 19.9758 9.39937L23.5114 5.86375C21.2789 3.78312 18.2927 2.5 15.0002 2.5C10.1989 2.5 6.03516 5.21062 3.94141 9.18188Z"
        fill="#FF3D00"
      />
      <path
        d="M15.0002 27.4999C18.2289 27.4999 21.1627 26.2643 23.3808 24.2549L19.5121 20.9812C18.2149 21.9677 16.6299 22.5012 15.0002 22.4999C11.7489 22.4999 8.98832 20.4268 7.94832 17.5337L3.87207 20.6743C5.94082 24.7224 10.1421 27.4999 15.0002 27.4999Z"
        fill="#4CAF50"
      />
      <path
        d="M27.2569 12.5519H26.25V12.5H15V17.5H22.0644C21.5714 18.8853 20.6833 20.0957 19.51 20.9819L19.5119 20.9806L23.3806 24.2544C23.1069 24.5031 27.5 21.25 27.5 15C27.5 14.1619 27.4137 13.3438 27.2569 12.5519Z"
        fill="#1976D2"
      />
    </svg>
  );
};
const SignUpFacebookIcon = () => {
  return (
    <svg
      style={{ cursor: "pointer" }}
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 0C6.26843 0 0 6.30627 0 14.0845C0 21.1134 5.11891 26.9393 11.813 28V18.1568H8.25663V14.0845H11.813V10.9814C11.813 7.44864 13.9034 5.50055 17.0999 5.50055C18.6317 5.50055 20.2362 5.77523 20.2362 5.77523V9.23896H18.4664C16.7303 9.23896 16.187 10.3264 16.187 11.4406V14.0817H20.0668L19.4465 18.1539H16.187V27.9972C22.8811 26.9422 28 21.1148 28 14.0845C28 6.30627 21.7316 0 14 0Z"
        fill="#1877F2"
      />
    </svg>
  );
};
